import { gql } from '@apollo/client'

import MoneyContent from '@Queries/cms/fragments/MoneyContent.fragment'

export default gql`
  ${MoneyContent}

  fragment RecommendedProducts on Product {
    id
    type
    brand {
      title
    }
    name
    url
    categoryIDs
    primaryCategories {
      id
      name(locale: "en-GB")
    }
    primaryAsset: asset(tag: "primary") {
      url
      tags
    }
    moneyShotAsset: asset(tag: "money_shot") {
      url
      tags
    }
    variants {
      id
      attributes {
        ... on IAttribute {
          key
        }
        ... on BaseAttribute {
          value
        }
      }
      availability {
        isInStock
        quantity
      }
      price {
        ...PriceFragment
      }
    }
    masterVariant {
      id
      personalizations: attribute(key: "personalizations") {
        ... on ProductAttribute {
          products {
            masterVariant {
              type: attribute(key: "type") {
                ... on BaseAttribute {
                  key
                  value
                }
              }
            }
          }
        }
        ... on BaseAttribute {
          key
          value
        }
      }
      price {
        ...MoneyContent
        discount {
          percent
          code {
            context
          }
          ...MoneyContent
        }
      }
      isNew: attribute(key: "isNew") {
        ... on BaseAttribute {
          value
        }
      }
      basePrice: price(currencyCode: "DKK") {
        plain: format(mode: NUMBER_PLAIN)
        discount {
          plain: format(mode: NUMBER_PLAIN)
        }
      }
    }
  }
`
